import { useFetch } from '@reveni-io/reveni-ui'

import { shouldIncludeRejectedItems } from '@/common/helpers/shipmentDeclaration/helpers'
import { isInboundParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'
import returnsServices from '@/returns/services/services'

import { transformRequestGenerateReturnLabel } from './transformers'

const useGenerateLabel = ({ storeId, parcel, refetchParcel }) => {
  const relatedId = parcel?.related?.id

  const { fetchData: generateShipmentLabel, loading: generatingShipmentLabel } = useFetch(
    () => parcelServices.generateLabel({ storeId, relatedId }),
    { doInitialRequest: false }
  )

  const { fetchData: generateReturnLabel, loading: generatingReturnLabel } = useFetch(
    returnsServices.generateReturnLabel,
    { doInitialRequest: false, transformRequest: transformRequestGenerateReturnLabel }
  )

  const onGenerateLabel = async () => {
    if (isInboundParcel(parcel)) {
      await generateReturnLabel({
        resourceId: relatedId,
        includeRejectedItems: shouldIncludeRejectedItems(parcel.related),
      })
    } else {
      await generateShipmentLabel()
    }

    await refetchParcel()
  }

  return { generatingLabel: generatingShipmentLabel || generatingReturnLabel, onGenerateLabel }
}

export default useGenerateLabel
